module.exports = __webpack_public_path__ + "img/qg4_11.3481a199.png";